import { render, staticRenderFns } from "./definiteDetail.vue?vue&type=template&id=38224669&scoped=true"
import script from "./definiteDetail.vue?vue&type=script&lang=js"
export * from "./definiteDetail.vue?vue&type=script&lang=js"
import style0 from "./definiteDetail.vue?vue&type=style&index=0&id=38224669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38224669",
  null
  
)

export default component.exports